// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userList {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
  padding-bottom: 200px;
  background-color: var(--background);
  padding: 8px;
  margin-bottom: 250px;
}

.userList-header {
  padding: 8px;
  padding-top: 4rem;
  background-color: var(--background);
  color: var(--text-primary);
}

.userList-header h2 {
  font-size: 18px;
}

.userList-header input {
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 3px;
  border: gainsboro solid 1px;
  width: 100%;
  font-size: 16px;
}

.recentSearches {
  padding: 8px;
  color: var(--text-primary);
  background-color: var(--background);
}

.searchGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.searchItem {
  background-color: var(--background-consistent);
  color: black;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px;
}

.searchItem:hover {
  background-color: #ebebeb;
}

.userCard {
  position: relative;
  width: 100%;
  padding-bottom: 46px;
  margin: 4px 0;
  padding-top: 8px;
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
  border-radius: 8px;
  background-color: var(--background-consistent);
  transition: box-shadow 0.2s ease-in-out;
}

.userCard:hover {
  box-shadow: rgb(0 0 0 / 25%) 0px 4px 12px;
}

.userImage {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: auto;
  display: block;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--theme-consistent);
}

.userCard button {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 0px;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  width: 80%;
  border: none;
  background-color: var(--theme-consistent);
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
}

.userCard button:disabled {
  background-color: var(--theme-consistent);
  opacity: 0.4;
  cursor: not-allowed;
}

.UserBody {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.UserBody h2 {
  font-size: 18px;
  margin: 0;
}

.UserBody p {
  font-size: 14px;
  color: #555;
  margin: 4px 0;
}

.searchItem {
  position: relative;
  background-color: var(--background-consistent);
  color: black;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchItemText {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loader-wrapper {
  width: 100%;
  min-height: 80vh; /* This ensures it takes up enough vertical space */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--background);
}

/* Tablet devices (min-width: 768px) */
@media screen and (min-width: 768px) {
  .userImage {
    width: 75px;
    height: 75px;
  }

  .userCard button {
    font-size: 12px;
    width: 70%;
  }

  .UserBody h2 {
    font-size: 20px;
  }

  .UserBody p {
    font-size: 16px;
  }
}

/* Desktop devices (min-width: 1024px) */
@media screen and (min-width: 1024px) {
  .userList {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
  }

  .userImage {
    width: 100px;
    height: 100px;
  }

  .userCard button {
    font-size: 14px;
    width: 60%;
  }

  .UserBody h2 {
    font-size: 24px;
  }

  .UserBody p {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/userList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,qBAAqB;EACrB,mCAAmC;EACnC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,mDAAmD;EACrE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,sCAAsC;AACtC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".userList {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 8px;\n  padding-bottom: 200px;\n  background-color: var(--background);\n  padding: 8px;\n  margin-bottom: 250px;\n}\n\n.userList-header {\n  padding: 8px;\n  padding-top: 4rem;\n  background-color: var(--background);\n  color: var(--text-primary);\n}\n\n.userList-header h2 {\n  font-size: 18px;\n}\n\n.userList-header input {\n  border-radius: 4px;\n  box-shadow: rgb(0 0 0 / 20%) 0px 3px 3px;\n  border: gainsboro solid 1px;\n  width: 100%;\n  font-size: 16px;\n}\n\n.recentSearches {\n  padding: 8px;\n  color: var(--text-primary);\n  background-color: var(--background);\n}\n\n.searchGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 20px;\n}\n\n.searchItem {\n  background-color: var(--background-consistent);\n  color: black;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px;\n}\n\n.searchItem:hover {\n  background-color: #ebebeb;\n}\n\n.userCard {\n  position: relative;\n  width: 100%;\n  padding-bottom: 46px;\n  margin: 4px 0;\n  padding-top: 8px;\n  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;\n  border-radius: 8px;\n  background-color: var(--background-consistent);\n  transition: box-shadow 0.2s ease-in-out;\n}\n\n.userCard:hover {\n  box-shadow: rgb(0 0 0 / 25%) 0px 4px 12px;\n}\n\n.userImage {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin: auto;\n  display: block;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--theme-consistent);\n}\n\n.userCard button {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 0px;\n  color: #fff;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  width: 80%;\n  border: none;\n  background-color: var(--theme-consistent);\n  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;\n}\n\n.userCard button:disabled {\n  background-color: var(--theme-consistent);\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.UserBody {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.UserBody h2 {\n  font-size: 18px;\n  margin: 0;\n}\n\n.UserBody p {\n  font-size: 14px;\n  color: #555;\n  margin: 4px 0;\n}\n\n.searchItem {\n  position: relative;\n  background-color: var(--background-consistent);\n  color: black;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.searchItemText {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.loader-wrapper {\n  width: 100%;\n  min-height: 80vh; /* This ensures it takes up enough vertical space */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--background);\n}\n\n/* Tablet devices (min-width: 768px) */\n@media screen and (min-width: 768px) {\n  .userImage {\n    width: 75px;\n    height: 75px;\n  }\n\n  .userCard button {\n    font-size: 12px;\n    width: 70%;\n  }\n\n  .UserBody h2 {\n    font-size: 20px;\n  }\n\n  .UserBody p {\n    font-size: 16px;\n  }\n}\n\n/* Desktop devices (min-width: 1024px) */\n@media screen and (min-width: 1024px) {\n  .userList {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n  }\n\n  .userImage {\n    width: 100px;\n    height: 100px;\n  }\n\n  .userCard button {\n    font-size: 14px;\n    width: 60%;\n  }\n\n  .UserBody h2 {\n    font-size: 24px;\n  }\n\n  .UserBody p {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
